// extracted by mini-css-extract-plugin
export default {"moji_Container":"Moji_moji_Container__uXsDE","moji_Wrapper":"Moji_moji_Wrapper__8YSTR","moji_Link":"Moji_moji_Link__RbhAL"};